import { mapEnumToOptions } from '@abp/ng.core';

export enum HabitationTypeCh {
  Appartement = 0,
  Maison = 1,
  NonRenseigne = -1,
}

export const habitationTypeChOptions = mapEnumToOptions(HabitationTypeCh);
